import React from "react";
import styles from "./signup.module.scss";
import Checked from "../../../assets/images/checkmark.svg";
import Proptypes from "prop-types";
import Button from "../../Shared/Button";
import { Link } from "react-router-dom";

const AuthAlerts = ({
  accountCreated,
  accountVerified,
  accountCreatedButNotVerified,
  buttonOnClick,
  linkOnClick,
}) => {
  if (accountCreated) {
    return (
      <>
        <div className={`${styles["signup_container"]}`}>
          <img src={Checked} alt="checked" width={80} height={80} />
          <div className={styles["header"]}>
            Your LRX Account has been created.
          </div>

          <div className={`${styles["label_body"]}`}>
            We just sent you an email with an activation link. Please check your
            inbox and click on the link to activate your account. If you don't
            see the email, check your spam folder.
          </div>

          <div className={styles["submit_button_container"]}>
            <Link to="/">
              <Button
                type="submit"
                className={styles["submit_button"]}
                text={"Go Back Login Page"}
              />
            </Link>
          </div>

          {/* <div
            className={styles["send_another_text"]}
            onClick={() => {
              linkOnClick && linkOnClick();
            }}
          >
            Send another activition email
          </div> */}
        </div>
      </>
    );
  } else if (accountCreatedButNotVerified) {
    return (
      <>
        <div className={`${styles["signup_container"]}`}>
          <div className={styles["header"]}>
            Hmmm, you need to verify your email first
          </div>
          <div className={`${styles["label_body"]}`}>
            We just sent you an email with an verification link. Please check
            your inbox and click on the link to verify your account. If you
            don't see the email, check your spam folder.
          </div>
          <div className={styles["submit_button_container"]}>
            <Button
              type="submit"
              className={styles["submit_button"]}
              onClick={() => {
                buttonOnClick();
              }}
              text={"Check inbox"}
            />
          </div>

          <div
            className={styles["send_another_text"]}
            onClick={() => {
              linkOnClick && linkOnClick();
            }}
          >
            Send another verification email
          </div>
        </div>
      </>
    );
  } else if (accountVerified) {
    return (
      <>
        <div className={`${styles["signup_container"]}`}>
          <img src={Checked} alt="checked" width={80} height={80} />
          <div className={styles["header"]}>
            Your LRX Account has been verified
          </div>
          <div
            className={`${styles["label_body"]} ${styles["label_body_verified"]}`}
          >
            Thank you for verifying your email, please login to continue to your
            dashboard.
          </div>
          <div className={styles["submit_button_container"]}>
            <Button
              type="submit"
              className={styles["submit_button"]}
              onClick={() => {
                buttonOnClick();
              }}
              text={"Login"}
            />
          </div>
        </div>
      </>
    );
  }
  return <></>;
};

AuthAlerts.propTypes = {
  accountCreated: Proptypes.bool,
  accountVerified: Proptypes.bool,
  buttonOnClick: Proptypes.func,
  linkOnClick: Proptypes.func,
  accountCreatedButNotVerified: Proptypes.bool,
};

export default AuthAlerts;
